module.exports = __webpack_public_path__ + "static/img/taikoo.2b8289d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taikoo.png
// module id = qVt1
// module chunks = 0